"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
require("react-loading-skeleton/dist/skeleton.css");
var use_theme_1 = __importDefault(require("../../global/use-theme"));
var SkeletonComponent = function (_a) {
    var _b = _a.lines, lines = _b === void 0 ? 4 : _b, _c = _a.duration, duration = _c === void 0 ? 1.5 : _c;
    var colours = use_theme_1.default().colours;
    return (react_1.default.createElement(react_loading_skeleton_1.default, { count: lines, baseColor: colours.skeleton.baseColor, duration: duration, highlightColor: colours.skeleton.highlight }));
};
SkeletonComponent.displayName = 'SkeletonComponent';
exports.default = SkeletonComponent;
